export default __webpack_public_path__ + "static/media/refferal-icon.42a5dd5e.png";